export default __webpack_public_path__ + "static/media/cube_yellow.02b9eb88.png";